import React, { useState } from 'react';
import styles from './ContactForm.module.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    _honey: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData._honey) return;
    console.log('Form submitted:', {
      name: formData.name,
      email: formData.email,
      message: formData.message,
    });
    setSubmitted(true);
    setFormData({ name: '', email: '', message: '', _honey: '' });
  };

  if (submitted) {
    return (
      <section id="contact" className="section">
        <div className="section__inner">
          <h2 className="section__title">Contact</h2>
          <div className={styles.success}>
            <h3 className={styles.successTitle}>Message delivered.</h3>
            <p className={styles.successSub}>The Puma council will review.</p>
            <button
              className="cta-btn cta-btn--outline"
              onClick={() => setSubmitted(false)}
            >
              SEND ANOTHER
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="contact" className="section">
      <div className="section__inner">
        <h2 className="section__title">Contact</h2>
        <form className={styles.form} onSubmit={handleSubmit}>
          <input
            type="text"
            name="_honey"
            value={formData._honey}
            onChange={handleChange}
            className={styles.honey}
            tabIndex={-1}
            autoComplete="off"
          />
          <div className={styles.field}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your name (optional)"
              className={styles.input}
            />
          </div>
          <div className={styles.field}>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your email"
              required
              className={styles.input}
            />
          </div>
          <div className={styles.field}>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Talk your talk. We'll respond."
              required
              rows={5}
              className={styles.textarea}
            />
          </div>
          <button type="submit" className="cta-btn">
            SEND IT
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
